// Exports
export default {
	"container": "container_BdP6K",
	"text": "text_9LhKB"
};
